import { useSuspenseQuery } from '@tanstack/react-query';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

import { getEvaluationItemValidationOptions, useValidateEvaluationItem } from './model/EvaluationItemValidationModel';

interface ValidationActionProps {
  itemId: Id;
  variant?: ValidationVariant;
  onAfterValidation?: () => void;
}

export function EvaluationItemValidationAction({ itemId, variant, onAfterValidation }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getEvaluationItemValidationOptions(itemId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateEvaluationItem(itemId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: () => {
        notification.success();
        if (onAfterValidation) {
          onAfterValidation();
        }
      },
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
